import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/providers/Store';

const getUserState = (state: RootState) => state.userSlice;

export const userSelectors = {
  getUser: createSelector(
    getUserState,
    (state) => state.user,
  ),
  getAuthorizationStatus: createSelector(
    getUserState,
    (state) => state.authorizationStatus,
  ),
  getIsLoading: createSelector(
    getUserState,
    (state) => state.isLoading,
  ),
  getRoles: createSelector(
    getUserState,
    (state) => state.roles,
  ),
  hasAdminRole: createSelector(
    getUserState,
    (state) => state.roles.includes('ADMIN'),
  ),
};
